/* TREAD Phase 2 behaviours: collection load-more, live filters, model-chip
   counts. No dependencies. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---- Size filter, page-local (owner order 2026-09-07) ----
  // The size filter belongs to the page the customer is on and nowhere
  // else: leaving a listing clears it. An earlier build carried the
  // choice between listings in sessionStorage; it re-applied silently and
  // could re-apply a value the catalogue no longer had, so a clean
  // collection URL answered with an empty store. That is gone — nothing
  // here writes storage, and a key an older visit left behind is dropped
  // on sight.
  var SIZE_KEY = 'tread_size';
  function isSizeParam(k) {
    return k.indexOf('filter.') === 0 && k.toLowerCase().indexOf('size') !== -1;
  }
  function activeSizes() {
    var out = { values: [] };
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (isSizeParam(k)) out.values.push(v);
      });
    } catch (e) { /* old browsers: the server-rendered chip still shows */ }
    return out;
  }
  function urlWithout(values) {
    var u = new URL(location.href);
    var keep = [];
    u.searchParams.forEach(function (v, k) {
      if (!isSizeParam(k) || values.indexOf(v) === -1) keep.push([k, v]);
    });
    u.search = '';
    keep.forEach(function (pair) { u.searchParams.append(pair[0], pair[1]); });
    return u.toString();
  }

  function initSizeFilter(root) {
    try { sessionStorage.removeItem(SIZE_KEY); } catch (e) { /* nothing to clean */ }
    var act = activeSizes();
    if (!act.values.length) return;

    // A value the catalogue no longer carries must be ignored, never
    // applied — otherwise a deleted size empties the shop. The live size
    // vocabulary comes from the shop-all facet itself, never a list here.
    fetch('/collections/shop-all?sections=tread-sizestrip-data')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['tread-sizestrip-data'] || '', 'text/html');
        var vocab = [].map.call(doc.querySelectorAll('.tread-chip'), function (c) { return c.textContent.trim(); });
        if (!vocab.length) return surface(act.values);
        var dead = act.values.filter(function (v) { return vocab.indexOf(v) === -1; });
        if (dead.length) {
          location.replace(urlWithout(dead));
          return;
        }
        surface(act.values);
      })
      .catch(function () { surface(act.values); });

    // An active filter must be impossible to miss. On a listing the filter
    // empties, Shopify still renders the size facet but marks nothing
    // active — and a size the collection never stocks is not in that list
    // at all — so neither the lit chip nor Clear comes from the server.
    // This puts both back whatever the server sent, and names the filter
    // in the empty state instead of the generic line.
    function surface(values) {
      var clearHref = urlWithout(values);
      var pick = root.querySelector('.tread-sizepick');

      if (!pick) {
        pick = document.createElement('div');
        pick.className = 'tread-sizepick';
        pick.setAttribute('data-tread-size-filter', '');
        pick.innerHTML =
          '<div class="tread-sizepick__top">' +
            '<span class="tread-sizepick__lab">Choose your size</span>' +
          '</div><div class="tread-sizepick__chips"></div>';
        var form = root.querySelector('[data-tread-filterform]');
        if (form && form.parentNode) form.parentNode.insertBefore(pick, form);
        else root.insertBefore(pick, root.firstChild);
      }

      var chipWrap = pick.querySelector('.tread-sizepick__chips');
      values.forEach(function (v) {
        var chip = null;
        [].slice.call(pick.querySelectorAll('.tread-sizepick__chip')).forEach(function (c) {
          if (!chip && c.textContent.trim() === v) chip = c;
        });
        if (!chip && chipWrap) {
          // the collection does not stock this size, so the facet omits
          // it — the customer still has to see what they asked for
          chip = document.createElement('a');
          chip.className = 'tread-sizepick__chip';
          chip.textContent = v;
          chipWrap.insertBefore(chip, chipWrap.firstChild);
        }
        if (!chip) return;
        chip.classList.add('on');
        chip.classList.remove('is-empty');
        chip.setAttribute('aria-current', 'true');
        if (chip.tagName === 'A') chip.setAttribute('href', clearHref);
      });

      if (!pick.querySelector('.tread-sizepick__clear')) {
        var top = pick.querySelector('.tread-sizepick__top');
        if (top) {
          var clr = document.createElement('a');
          clr.className = 'tread-sizepick__clear';
          clr.setAttribute('href', clearHref);
          clr.textContent = 'Clear';
          top.appendChild(clr);
        }
      }

      var empty = root.querySelector('[data-tread-empty]');
      if (!empty) return;
      var where = (root.querySelector('.tread-chead h1') || {}).textContent;
      where = where ? where.trim() : '';
      var line = document.createElement('p');
      line.textContent = where
        ? 'No ' + where + ' in size ' + values.join(', ') + '.'
        : 'Nothing here in size ' + values.join(', ') + '.';
      var out = document.createElement('a');
      out.className = 'tread-btn tread-btn--secondary';
      out.setAttribute('href', clearHref);
      out.textContent = 'Show all sizes';
      empty.innerHTML = '';
      empty.appendChild(line);
      empty.appendChild(out);
    }
  }

  ready(function () {
    var root = document.querySelector('[data-tread-collection]');
    if (root) { initSizeFilter(root); initCollection(root); }
    var pdp = document.querySelector('[data-tread-product]');
    if (pdp) initProduct(pdp);
    var dealModal = document.querySelector('[data-tread-deal-modal]');
    if (dealModal) initDealModal(dealModal);
    document.querySelectorAll('[data-tread-featured]').forEach(initFeatured);
    document.querySelectorAll('[data-tread-motion]').forEach(initMotionPause);
    initMotionArbiter();
    var sizestrip = document.querySelector('[data-tread-sizestrip]');
    if (sizestrip) initSizestrip(sizestrip);
    // the category rail clones its cards before counts are collected,
    // so the rail must initialise first
    var catRail = document.querySelector('[data-tread-cat-rail]');
    if (catRail) initCatRail(catRail);
    var cats = document.querySelector('[data-tread-categories]');
    if (cats) initCategories(cats);
    var rotator = document.querySelector('[data-tread-rotator]');
    if (rotator) initHeroRotator(rotator);
    var heroVideo = document.querySelector('[data-tread-hero-video]');
    if (heroVideo) initHeroVideo(heroVideo);
    initBrandCounts();
    initDrift();
  });

  function initMotionPause(el) {
    // Hover pause is CSS; touch pauses too, resuming shortly after release.
    var timer = null;
    el.addEventListener('touchstart', function () {
      if (timer) clearTimeout(timer);
      el.classList.add('is-paused');
    }, { passive: true });
    var resume = function () {
      timer = setTimeout(function () { el.classList.remove('is-paused'); }, 2500);
    };
    // touchcancel fires when the browser takes over the gesture (e.g.
    // touch-scroll); without it the pause sticks forever.
    el.addEventListener('touchend', resume, { passive: true });
    el.addEventListener('touchcancel', resume, { passive: true });
  }

  function initMotionArbiter() {
    // v2 (owner order 2026-08-31, after the mobile diagnosis: DOM-order
    // arbitration let a 44px divider sliver or the previous rail's edge
    // freeze every rail on phones). The strip is exempt and always runs.
    // Rails outrank dividers: a divider runs only when no rail is on
    // screen. Among visible rails, the one occupying the most viewport
    // area runs; the rest pause. Event-driven — no animation loops.
    var dividers = [].slice.call(document.querySelectorAll('.tread-divider[data-tread-motion]'));
    var rails = [].slice.call(document.querySelectorAll('[data-tread-rail]'));
    var movers = dividers.concat(rails);
    if (!movers.length || !('IntersectionObserver' in window)) return;
    function visFrac(el) {
      var b = el.getBoundingClientRect();
      if (b.bottom <= 0 || b.top >= innerHeight || !b.height) return 0;
      return (Math.min(b.bottom, innerHeight) - Math.max(b.top, 0)) / b.height;
    }
    function apply() {
      var winner = null;
      var best = 0.05;
      var anyRail = false;
      rails.forEach(function (r) {
        var f = visFrac(r);
        if (f > 0) anyRail = true;
        if (f > best) { best = f; winner = r; }
      });
      rails.forEach(function (r) {
        r.classList.toggle('is-arbited', r !== winner && visFrac(r) > 0);
      });
      var firstDiv = null;
      dividers.forEach(function (d) { if (!firstDiv && visFrac(d) > 0) firstDiv = d; });
      dividers.forEach(function (d) {
        d.classList.toggle('is-arbited', visFrac(d) > 0 && (anyRail || d !== firstDiv));
      });
    }
    var io = new IntersectionObserver(apply, { threshold: [0, 0.15, 0.35, 0.55, 0.75, 0.95] });
    movers.forEach(function (m) { io.observe(m); });
    addEventListener('scroll', apply, { passive: true });
    apply();
  }

  function initHeroRotator(el) {
    // Words are server-rendered from the section's tag blocks. This runs
    // once: measure the widest rendered word, reserve the slot so nothing
    // shifts while cycling, set static per-word delays, go live.
    var spans = [].slice.call(el.querySelectorAll('.tread-hero__word'));
    if (!spans.length) return;
    var maxW = 0;
    var maxH = 0;
    spans.forEach(function (s) {
      var prevDisplay = s.style.display;
      s.style.display = 'inline-block';
      maxW = Math.max(maxW, s.offsetWidth);
      maxH = Math.max(maxH, s.offsetHeight);
      s.style.display = prevDisplay;
    });
    el.style.width = Math.ceil(maxW) + 'px';
    el.style.height = Math.ceil(maxH) + 'px';
    spans.forEach(function (s, i) {
      s.style.setProperty('--tread-word-delay', (i * 3) + 's');
    });
    el.classList.add('is-live');
  }

  function initCatRail(el) {
    // Category rail (owner clarification 2026-08-31): a carousel, not a
    // glide, at every width — one whole card each 2.5s.
    initStepRail(el);
  }

  function initStepRail(el) {
    // Carousel: one snapped card advances every 2.5s via native smooth
    // scrolling (no JS animation loop). The card set is duplicated so
    // the wrap is one more forward step — before stepping out of the
    // original set the position is rebased a full set back, which is
    // invisible because the content is identical. Touch or hover stops
    // it at once (a scrollLeft write also cancels any smooth scroll in
    // flight, so a tap lands on the card it touched); it resumes 2.5s
    // after release from wherever the customer left it.
    if (el.getAttribute('data-rail-ready')) return;
    el.setAttribute('data-rail-ready', '1');
    var cards = [].slice.call(el.children);
    if (cards.length < 2) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Nothing is cloned any more. Filling the track with copies printed the
    // same category three and four times over, which reads as a fault
    // rather than as a rail (owner, 2026-10-28). The track holds each tile
    // once; when it reaches the end it rewinds, and when the tiles already
    // fit it does not step at all.
    var n = cards.length;
    var sets = 1;
    // The rebase needs one whole set of travel beyond the viewport. When
    // cards are hidden after this ran — the category gate does exactly
    // that — two sets can be narrower than that, the step lands past the
    // end and the rail parks there for good. So top the track up lazily
    // with more copies of the same set until the wrap is reachable
    // (owner-reported 2026-09-07).
    function fits() {
      return el.scrollWidth <= el.clientWidth + 4;
    }
    var userHold = false;
    var holdTimer = null;
    var timer = null;
    function visible() {
      var b = el.getBoundingClientRect();
      return b.bottom > 0 && b.top < innerHeight;
    }
    function stepSize() {
      var a = el.children[0];
      var b = el.children[1];
      return b ? (b.offsetLeft - a.offsetLeft) : a.offsetWidth;
    }
    function step() {
      if (userHold || el.classList.contains('is-arbited') || !visible() || document.hidden) return;
      // A track whose tiles already fit has nothing to show by moving.
      if (fits()) { stopAll(); return; }
      var s = stepSize();
      if (!s) return;
      var i = Math.round(el.scrollLeft / s);
      var last = Math.max(0, Math.ceil((el.scrollWidth - el.clientWidth) / s));
      if (i >= last) {
        el.scrollTo({ left: 0, behavior: 'smooth' });   // rewind, never repeat
        return;
      }
      el.scrollTo({ left: (i + 1) * s, behavior: 'smooth' });
    }
    function start() {
      if (reduce.matches || timer) return;
      timer = setInterval(step, 2500);
    }
    function stopAll() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function hold() {
      userHold = true;
      el.scrollLeft = el.scrollLeft; // cancels a smooth scroll in flight
      if (holdTimer) clearTimeout(holdTimer);
    }
    function release() {
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { userHold = false; }, 2500);
    }
    el.addEventListener('pointerdown', hold);
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('mouseenter', hold);
    el.addEventListener('mouseleave', release);
    el.addEventListener('touchstart', hold, { passive: true });
    el.addEventListener('touchend', release, { passive: true });
    el.addEventListener('touchcancel', release, { passive: true });
    el.addEventListener('focusin', hold);
    el.addEventListener('focusout', release);
    if (!reduce.matches) start();
    if (reduce.addEventListener) {
      reduce.addEventListener('change', function (e) {
        if (e.matches) stopAll();
        else start();
      });
    }
  }

  function initHeroVideo(el) {
    // Mobile banner video (owner order 2026-08-30). Muted inline loop;
    // prefers-reduced-motion pauses it entirely, and it only plays while
    // the CSS actually shows it (phones).
    el.muted = true;
    var hr = window.matchMedia('(prefers-reduced-motion: reduce)');
    function sync() {
      if (hr.matches) {
        el.removeAttribute('autoplay');
        el.pause();
      } else if (getComputedStyle(el).display !== 'none') {
        var p = el.play();
        if (p && p.catch) p.catch(function () { /* blocked autoplay stays paused */ });
      }
    }
    sync();
    if (hr.addEventListener) hr.addEventListener('change', sync);
  }

  function initRail(el, loader) {
    // Product rail v3 (owner spec 2026-08-31): continuous glide, native
    // touch momentum — no scroll snap, so a swipe eases out instead of
    // halting on a card edge. The glide halts on hover/touch/focus, under
    // arbitration, off-screen, in hidden tabs, and always under
    // prefers-reduced-motion; it resumes 2.5s after release from wherever
    // the customer left it. As the end approaches, `loader` appends the
    // next page from the rail's own source (item 3: never runs out, no
    // preloading); once the source is exhausted the cards repeat from the
    // start by cloning forward, so there is never a visible rewind.
    if (el.getAttribute('data-rail-ready')) return;
    el.setAttribute('data-rail-ready', '1');
    if (el.children.length < 1) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var userHold = false;
    var holdTimer = null;
    var running = false;
    var loading = false;
    var cycleSeq = null;
    var cycleIdx = 0;
    // scrollLeft truncates sub-pixel writes, so a 0.5px/frame glide must
    // accumulate in a float and only then be written back.
    var pos = el.scrollLeft;
    function visible() {
      var b = el.getBoundingClientRect();
      return b.bottom > 0 && b.top < innerHeight;
    }
    function cyclic() {
      if (!cycleSeq) { cycleSeq = [].slice.call(el.children); cycleIdx = 0; }
      if (!cycleSeq.length) return;
      for (var i = 0; i < 6; i++) {
        el.appendChild(cycleSeq[cycleIdx % cycleSeq.length].cloneNode(true));
        cycleIdx++;
      }
    }
    function topUp() {
      if (loading) return;
      if (el.scrollLeft + el.clientWidth * 2.5 < el.scrollWidth) return;
      loading = true;
      var p = loader ? loader() : null;
      if (p && p.then) {
        p.then(function (appended) {
          loading = false;
          if (!appended) cyclic();
          topUp(); // keep filling until the buffer is ahead again
        }).catch(function () { loading = false; cyclic(); topUp(); });
      } else {
        loading = false;
        cyclic();
        if (el.scrollLeft + el.clientWidth * 2.5 >= el.scrollWidth) topUp();
      }
    }
    function step() {
      if (!running) return;
      if (!userHold && !el.classList.contains('is-arbited') && visible() && !document.hidden) {
        if (Math.abs(el.scrollLeft - pos) > 1.5) pos = el.scrollLeft;
        pos += 0.5;
        el.scrollLeft = pos;
      }
      requestAnimationFrame(step);
    }
    function start() {
      if (reduce.matches || running) return;
      running = true;
      requestAnimationFrame(step);
    }
    function stopAll() { running = false; }
    function hold() {
      userHold = true;
      if (holdTimer) clearTimeout(holdTimer);
    }
    function release() {
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { userHold = false; }, 2500);
    }
    // stop before any tap resolves
    el.addEventListener('pointerdown', hold);
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('mouseenter', hold);
    el.addEventListener('mouseleave', release);
    el.addEventListener('touchstart', hold, { passive: true });
    el.addEventListener('touchend', release, { passive: true });
    el.addEventListener('touchcancel', release, { passive: true });
    el.addEventListener('focusin', hold);
    el.addEventListener('focusout', release);
    el.addEventListener('wheel', function () { hold(); release(); }, { passive: true });
    // any movement — the glide or a swipe — can trigger a top-up
    el.addEventListener('scroll', topUp, { passive: true });
    topUp();
    if (reduce.matches) stopAll();
    else start();
    if (reduce.addEventListener) {
      reduce.addEventListener('change', function (e) {
        if (e.matches) stopAll();
        else start();
      });
    }
  }

  function initDrift() {
    // Almost every customer here is on a phone. A band that keeps animating
    // below the fold costs scroll smoothness and battery for nothing, so a
    // band runs only while it is on screen — and never at all when the
    // browser asks for less data (owner order 2026-10-27).
    var bands = [].slice.call(document.querySelectorAll('[data-tread-drift]'));
    if (!bands.length) return;
    var conn = navigator.connection || {};
    if (conn.saveData) return;                 // stays still, pairs still show
    if (!('IntersectionObserver' in window)) {
      bands.forEach(function (b) { b.classList.add('is-drifting'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-drifting', e.isIntersecting);
      });
    }, { rootMargin: '120px 0px' });
    bands.forEach(function (b) { io.observe(b); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) bands.forEach(function (b) { b.classList.remove('is-drifting'); });
    });
  }

  function initBrandCounts() {
    // Vendors without a brand collection: the count comes live from the
    // built-in vendor listing itself (computed, never guessed; on any
    // failure the count stays omitted).
    [].slice.call(document.querySelectorAll('[data-brand-count-src]')).forEach(function (el) {
      var src = el.getAttribute('data-brand-count-src');
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      fetch(src + sep + 'sections=tread-catcount')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data['tread-catcount'] || '', 'text/html');
          // tread-catcount answers "total|withImage|sampled". Stripping
          // every non-digit glued the three together, so a brand with one
          // pair read "111". Only the first field is the count.
          var n = parseInt(doc.body.textContent.trim().split('|')[0], 10);
          if (n > 0) el.textContent = n + (n === 1 ? ' pair' : ' pairs');
        })
        .catch(function () { /* count stays omitted */ });
    });
  }

  function initCategories(root) {
    // The rail decides its own tiles from live data (owner spec
    // 2026-09-07): a category shows only when at least MIN of its live
    // products carry an image. Nothing is hand-listed — the section
    // offers every category tag it knows about and this gate decides
    // which survive, so a category that grows past the line reappears on
    // its own and one that falls below it leaves on its own.
    //
    // Cards are hidden the moment this runs, so a tile that will not
    // qualify never flashes on screen; with JavaScript off nothing hides
    // and the rail degrades to every tile rather than to none.
    var MIN = 10;
    var srcs = {};
    var cards = [].slice.call(root.querySelectorAll('[data-cat-src]'));
    if (!cards.length) return;
    cards.forEach(function (a) {
      var s = a.getAttribute('data-cat-src');
      (srcs[s] = srcs[s] || []).push(a);
      a.hidden = true;
    });
    var pending = Object.keys(srcs).length;
    function settle() {
      pending -= 1;
      if (pending > 0) return;
      // Nothing cleared the line: drop the whole section rather than
      // leave a heading over an empty rail.
      if (!root.querySelector('[data-cat-src]:not([hidden])')) root.hidden = true;
    }
    Object.keys(srcs).forEach(function (src) {
      fetch(src + '?sections=tread-catcount')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data['tread-catcount'] || '', 'text/html');
          var parts = doc.body.textContent.trim().split('|');
          var total = parseInt(parts[0], 10);
          var withImage = parseInt(parts[1], 10);
          var shot = (parts[3] || '').trim();
          // A listing that cannot field MIN photographed pairs is not
          // worth a tile — the customer would land on a thin or empty page.
          if (!(withImage >= MIN)) return settle();
          srcs[src].forEach(function (a) {
            var im = a.querySelector('[data-cat-img]');
            if (im && shot) {
              im.src = shot;
              im.removeAttribute('hidden');
            }
            var span = a.querySelector('[data-cat-count]');
            if (span && total) {
              span.textContent = total + (total === 1 ? ' pair' : ' pairs');
              span.removeAttribute('hidden');
            }
            a.hidden = false;
          });
          settle();
        })
        .catch(function () {
          // Count unknown: leave the tile hidden. Guessing here is what
          // sends a customer to an empty page.
          settle();
        });
    });
  }

  function initSizestrip(el) {
    // Sizes straight from the live Shoe size facet — whole sizes 36–48
    // only in this section (owner spec 2026-08-31, item 5); half sizes
    // stay available in the collection filters.
    var wrap = el.querySelector('[data-tread-sizestrip-chips]');
    var src = el.getAttribute('data-source-url');
    if (!wrap || !src) return;
    fetch(src + '?sections=tread-sizestrip-data')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['tread-sizestrip-data'] || '', 'text/html');
        var chips = [].filter.call(doc.querySelectorAll('.tread-chip'), function (c) {
          var t = c.textContent.trim();
          if (!/^\d+$/.test(t)) return false;
          var n = parseInt(t, 10);
          return n >= 36 && n <= 48;
        });
        if (!chips.length) return;
        wrap.innerHTML = '';
        chips.forEach(function (c) { wrap.appendChild(c); });
      })
      .catch(function () { /* fallback link stays */ });
  }

  function cardVendor(c) {
    var v = c.querySelector('.tread-card__vendor');
    return v ? v.textContent.trim() : '';
  }

  function cardModelBase(c) {
    // The model, as far as a card can know it: the title with the brand
    // taken off the front and any quoted segment removed — the store
    // writes colourways in quotes, so what is left is the model line.
    var v = cardVendor(c);
    var n = c.querySelector('.tread-card__name');
    var t = (n ? n.textContent : '').trim();
    if (v && t.toLowerCase().indexOf(v.toLowerCase()) === 0 &&
        (t.length === v.length || /\s/.test(t.charAt(v.length)))) t = t.slice(v.length);
    t = t.replace(/['"\u2018\u2019\u201c\u201d][^'"\u2018\u2019\u201c\u201d]*['"\u2018\u2019\u201c\u201d]/g, ' ');
    return t.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function makeModelKeyer() {
    // Colourways that are NOT quoted still have to fold together, and no
    // hand-written colour list decides that (owner rule: never a written
    // list). Instead, within one brand, a longer model line that begins
    // with a shorter one already seen is the same model wearing a colour:
    // "Campus 00s Grey Clear Sky" folds into "Campus 00s". Purely from
    // the catalogue's own text (owner order 2026-09-07).
    // Containment is on whole words and in either position, so a line with
    // an extra word in FRONT folds in too: "Zoom Vomero 5" is "Vomero 5"
    // (owner order 2026-09-07). A fragment under three characters never
    // absorbs anything — a bare "1" would swallow a brand's whole shelf.
    function holds(long, short) {
      if (long === short) return true;
      if (short.length < 3) return false;
      return (' ' + long + ' ').indexOf(' ' + short + ' ') >= 0;
    }
    var known = {};
    return function (c) {
      var v = cardVendor(c);
      var base = cardModelBase(c);
      var list = known[v] = known[v] || [];
      for (var i = 0; i < list.length; i++) {
        // The key a model was first filed under never changes, even when a
        // later, shorter line becomes the better yardstick — otherwise a
        // model already on screen would look new and show twice.
        if (holds(base, list[i].cmp)) return list[i].key;
        if (holds(list[i].cmp, base)) { list[i].cmp = base; return list[i].key; }
      }
      list.push({ cmp: base, key: v + '|' + base });
      return v + '|' + base;
    };
  }

  function initFeatured(sec) {
    // Home product rows: server-rendered start, then an endless rail —
    // each page fetched from the row's own source only as the end nears
    // (owner spec 2026-08-31, item 3). One card per model throughout.
    //
    // The row must never show anything other than what its heading
    // claims. It used to keep the server-rendered opening — plain
    // shop-all — whenever its own source came back empty, so a heading
    // like "Court sneakers" sat over the newest products in the shop and
    // said something untrue. Now a tagged or sorted row starts hidden,
    // and only appears once its own source has returned at least MIN_ROW
    // distinct products. Under that, it stays gone: an absent row is
    // honest, a row of the wrong products is not (owner order
    // 2026-09-07).
    var MIN_ROW = 6;
    var grid = sec.querySelector('[data-tread-featured-grid]');
    var tag = sec.getAttribute('data-tag');
    var sort = sec.getAttribute('data-sort');
    var collUrl = sec.getAttribute('data-collection-url');
    if (!grid) return;
    var base = tag ? '/collections/all/' + tag : collUrl;
    var seen = {};
    var page = 0;
    var exhausted = false;
    var buffer = [];
    var modelKey = makeModelKeyer();
    var vendorUse = {};
    var sortParam = sort ? '&sort_by=' + sort : '';

    function orderByBrand(list) {
      // One product per brand before any brand comes round again, so a
      // row never opens with five of the same label (owner order
      // 2026-09-07). Ties keep the source's own order.
      var out = [];
      var rest = list.slice();
      while (rest.length) {
        var at = 0;
        var low = Infinity;
        for (var i = 0; i < rest.length; i++) {
          var u = vendorUse[cardVendor(rest[i])] || 0;
          if (u < low) { low = u; at = i; if (u === 0) break; }
        }
        var pick = rest.splice(at, 1)[0];
        vendorUse[cardVendor(pick)] = (vendorUse[cardVendor(pick)] || 0) + 1;
        out.push(pick);
      }
      return out;
    }
    function collect(doc) {
      var got = [].slice.call(doc.querySelectorAll('.tread-card'));
      buffer = buffer.concat(got);
      return got.length;
    }
    function flush() {
      // Everything buffered is de-duplicated by model and then dealt out
      // one brand at a time. Two pages are buffered before the first
      // flush, because a single page of a listing sorted by date can be
      // one brand's whole delivery — with only that page in hand there
      // is nothing to rotate between (owner order 2026-09-07).
      var incoming = buffer;
      buffer = [];
      incoming.sort(function (x, y) { return cardModelBase(x).length - cardModelBase(y).length; });
      var fresh = [];
      incoming.forEach(function (c) {
        var key = modelKey(c);
        if (seen[key]) return;
        seen[key] = 1;
        fresh.push(c);
      });
      orderByBrand(fresh).forEach(function (c) { grid.appendChild(c); });
      return fresh.length;
    }
    function fetchPage(n) {
      return fetch(base + '?sections=tread-cardstrip&page=' + n + sortParam)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data['tread-cardstrip'] || '', 'text/html');
          var got = doc.querySelectorAll('.tread-card').length;
          if (got) collect(doc);
          return got;
        });
    }
    function loadNext() {
      if (exhausted || !base) return Promise.resolve(false);
      page += 1;
      return fetchPage(page).then(function (got) {
        if (!got) { exhausted = true; return false; }
        if (flush() === 0) return loadNext();   // page held only repeats
        return true;
      });
    }
    function shownCount() {
      return grid.querySelectorAll('.tread-card').length;
    }
    // Collapsing colourways can take the opening pages below the line
    // while the source still holds plenty — so keep asking for pages
    // until the row either has MIN_ROW distinct models or the source
    // runs out. The decision is about the source's real depth.
    function fillThenDecide(depth) {
      if (shownCount() >= MIN_ROW) {
        sec.hidden = false;
        initRail(grid, loadNext);
        return;
      }
      if (depth > 12) return;               // stays hidden
      loadNext().then(function (more) {
        if (!more) return;                  // exhausted and still short
        fillThenDecide(depth + 1);
      }).catch(function () { /* stays hidden */ });
    }

    sec.hidden = true;
    if (!tag && !sort) {
      // the server-rendered opening is page 1: take it in hand rather
      // than on screen, so it can be ordered together with page 2
      var start = [].slice.call(grid.querySelectorAll('.tread-card'));
      start.forEach(function (c) { c.remove(); });
      buffer = buffer.concat(start);
      page = 1;
      fetchPage(2)
        .then(function (got) { page = 2; if (!got) exhausted = true; })
        .catch(function () { /* page 2 unreachable: page 1 alone it is */ })
        .then(function () { flush(); fillThenDecide(0); });
      return;
    }
    // Tagged or sorted rows: nothing shows until their own source has
    // answered, so the opening cards are never seen under this heading.
    fetchPage(1)
      .then(function (got) {
        grid.innerHTML = '';
        if (!got) { page = 1; exhausted = true; return; }
        return fetchPage(2).then(function (g2) { page = 2; if (!g2) exhausted = true; });
      })
      .then(function () { flush(); fillThenDecide(0); })
      .catch(function () { /* source unreachable: the row stays hidden */ });
  }

  function initProduct(root) {
    // Gallery: framed images, arrows, "n / N" counter, progress dashes.
    var track = root.querySelector('[data-tread-gallery-track]');
    if (track) {
      var frames = track.querySelectorAll('.tread-gal__frame');
      var count = root.querySelector('[data-tread-gallery-count]');
      var dashes = root.querySelectorAll('[data-tread-gallery-dashes] .tread-gal__dash');
      var idx = 0;
      function step() { return frames.length > 1 ? frames[1].offsetLeft - frames[0].offsetLeft : track.clientWidth; }
      function paint() {
        if (count) count.textContent = (idx + 1) + ' / ' + frames.length;
        dashes.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
      }
      function go(delta) {
        idx = Math.max(0, Math.min(frames.length - 1, idx + delta));
        track.scrollTo({ left: idx * step(), behavior: 'smooth' });
        paint();
      }
      root.querySelector('[data-tread-gallery-prev]').addEventListener('click', function () { go(-1); });
      root.querySelector('[data-tread-gallery-next]').addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / step());
        idx = Math.max(0, Math.min(frames.length - 1, i));
        paint();
      }, { passive: true });
    }

    // Size buttons select the matching variant. sizeChosen tracks an
    // EXPLICIT tap — the server-side default selection does not count
    // for the pinned bar's "Choose your size" prompt.
    var input = root.querySelector('[data-tread-variant-input]');
    var sizeChosen = false;
    var syncBar = function () {};
    root.querySelectorAll('.tread-sizegrid__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-available') === 'false') return;
        root.querySelectorAll('.tread-sizegrid__btn.sel').forEach(function (b) { b.classList.remove('sel'); });
        btn.classList.add('sel');
        if (input) input.value = btn.getAttribute('data-variant-id');
        sizeChosen = true;
        syncBar();
      });
    });

    // Buy it now: add the selected variant, go to checkout.
    var buyNow = root.querySelector('[data-tread-buynow]');
    if (buyNow && input) {
      buyNow.addEventListener('click', function () {
        buyNow.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(input.value), quantity: 1 }),
        }).then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyNow.removeAttribute('aria-busy'); });
      });
    }

    // Mobile: the sections collapse into accordions.
    if (window.matchMedia('(max-width: 767px)').matches) {
      root.querySelectorAll('.tread-accs details[open]').forEach(function (d) { d.removeAttribute('open'); });
    }

    // Colour swatches: every colourway of this model (same model: tag).
    var swatchWrap = root.querySelector('[data-tread-swatches]');
    var modelUrl = root.getAttribute('data-model-tag-url');
    if (swatchWrap && modelUrl) {
      fetch(modelUrl + '?sections=tread-swatches')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data['tread-swatches'] || '', 'text/html');
          var items = doc.querySelectorAll('.tread-swatch__item');
          if (items.length < 2) return;
          swatchWrap.innerHTML = '';
          var current = root.getAttribute('data-handle');
          items.forEach(function (a) {
            if (a.getAttribute('data-handle') === current) {
              a.classList.add('sel');
              a.setAttribute('aria-current', 'page');
            }
            swatchWrap.appendChild(a);
          });
          // Cap (owner spec 2026-09-01): first 10 swatches, then a
          // "+N more" chip that expands the rest in place. The selected
          // colourway is always visible even outside the first 10.
          var list = [].slice.call(swatchWrap.querySelectorAll('.tread-swatch__item'));
          if (list.length > 11) {
            var hiddenCount = 0;
            list.forEach(function (it, i) {
              if (i >= 10 && !it.classList.contains('sel')) {
                it.hidden = true;
                hiddenCount++;
              }
            });
            if (hiddenCount > 0) {
              var moreChip = document.createElement('button');
              moreChip.type = 'button';
              moreChip.className = 'tread-swatch__more';
              moreChip.textContent = '+' + hiddenCount + ' more';
              moreChip.addEventListener('click', function () {
                list.forEach(function (it) { it.hidden = false; });
                moreChip.remove();
              });
              swatchWrap.appendChild(moreChip);
            }
          }
        })
        .catch(function () { /* keep the self swatch */ });
    }

    // "You might also like" — a real rail (owner spec 2026-08-31, item 4):
    // same model first, then same brand, then same category, never the
    // product being viewed, appending more as the customer scrolls. The
    // meta line reflects the sources actually shown.
    var related = root.querySelector('[data-tread-related]');
    var catUrl = root.getAttribute('data-category-tag-url');
    var vendor = (root.getAttribute('data-vendor') || '');
    if (related) {
      var currentHandle = root.getAttribute('data-handle');
      var sources = [];
      if (modelUrl) sources.push({ url: modelUrl, label: 'Same model' });
      if (vendor) sources.push({ url: '/collections/vendors?q=' + encodeURIComponent(vendor), label: 'same brand' });
      if (catUrl) sources.push({ url: catUrl, label: 'same category' });
      var si = 0;
      var rpage = 0;
      var seenHandles = {};
      seenHandles[currentHandle] = 1;
      var usedLabels = [];
      var meta = root.querySelector('[data-tread-related-meta]');
      function handleOf(c) {
        var a = c.matches('a[href]') ? c : c.querySelector('a[href]');
        var href = a ? a.getAttribute('href') : '';
        return (href.split('?')[0].split('/').pop()) || '';
      }
      function relLoad() {
        if (si >= sources.length) return Promise.resolve(false);
        var src = sources[si];
        rpage += 1;
        var sep = src.url.indexOf('?') > -1 ? '&' : '?';
        return fetch(src.url + sep + 'sections=tread-cardstrip&page=' + rpage)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var doc = new DOMParser().parseFromString(data['tread-cardstrip'] || '', 'text/html');
            var cards = doc.querySelectorAll('.tread-card');
            if (!cards.length) { si += 1; rpage = 0; return relLoad(); }
            var added = 0;
            [].forEach.call(cards, function (c) {
              var h = handleOf(c);
              if (!h || seenHandles[h]) return;
              seenHandles[h] = 1;
              related.appendChild(c);
              added++;
            });
            if (added) {
              if (usedLabels.indexOf(src.label) === -1) usedLabels.push(src.label);
              if (meta) meta.textContent = usedLabels.join(' · ');
              return true;
            }
            return relLoad();
          });
      }
      relLoad().then(function (ok) {
        if (!ok && !related.children.length) { hideRelated(root); return; }
        initRail(related, relLoad);
      }).catch(function () {
        if (!related.children.length) hideRelated(root);
      });
    }

    // Mobile pinned bar (owner spec 2026-09-01): appears as soon as the
    // GALLERY scrolls out of view. Reads "Choose your size" until the
    // customer explicitly taps a size, then switches to the buy buttons.
    // Tapping the prompt scrolls to the size buttons and highlights them.
    var cta = root.querySelector('.tread-buy__cta');
    var sizegrid = root.querySelector('[data-tread-sizes]');
    var gal = root.querySelector('.tread-gal');
    var chooseBtn = root.querySelector('[data-tread-choose-size]');
    var addBtn = root.querySelector('[data-tread-add]');
    if (cta && gal && window.matchMedia('(max-width: 767px)').matches) {
      var spacer = document.createElement('div');
      spacer.setAttribute('data-tread-cta-spacer', '');
      var pinned = false;
      syncBar = function () {
        var showChoose = pinned && !sizeChosen && chooseBtn && sizegrid;
        if (chooseBtn) chooseBtn.hidden = !showChoose;
        if (addBtn) addBtn.hidden = !!showChoose;
        if (buyNow) buyNow.hidden = !!showChoose;
      };
      var syncPin = function () {
        var out = gal.getBoundingClientRect().bottom < 0;
        if (out === pinned) return;
        pinned = out;
        if (pinned) {
          spacer.style.height = cta.offsetHeight + 'px';
          cta.parentNode.insertBefore(spacer, cta);
          cta.classList.add('is-pinned');
        } else {
          cta.classList.remove('is-pinned');
          if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
        }
        syncBar();
      };
      if (chooseBtn) {
        chooseBtn.addEventListener('click', function () {
          if (!sizegrid) return;
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          sizegrid.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          sizegrid.classList.add('hl');
          setTimeout(function () { sizegrid.classList.remove('hl'); }, 1600);
        });
      }
      addEventListener('scroll', syncPin, { passive: true });
      syncPin();
      syncBar();
    }

    // "More {vendor}": distinct sibling model names, plain text.
    var moreWrap = root.querySelector('[data-tread-more-vendor]');
    var moreList = root.querySelector('[data-tread-more-vendor-list]');
    if (moreWrap && moreList && vendor) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(vendor) + '&resources[type]=product&resources[limit]=10')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = ((data.resources || {}).results || {}).products || [];
          var models = [];
          products.forEach(function (p) {
            if ((p.vendor || '').toLowerCase() !== vendor) return;
            var m = p.title.split("'")[0].trim();
            if (m.toLowerCase().indexOf(vendor) === 0) m = m.slice(vendor.length).trim();
            if (m && models.indexOf(m) === -1) models.push(m);
          });
          if (!models.length) return;
          moreList.textContent = models.slice(0, 6).join(' · ');
          moreWrap.removeAttribute('hidden');
        })
        .catch(function () { /* stays hidden */ });
    }
  }

  function hideRelated(root) {
    var band = root.querySelector('.tread-band');
    var sec = root.querySelector('[data-tread-related]');
    if (sec && sec.closest('.tread-sec')) sec.closest('.tread-sec').remove();
    if (band) band.remove();
  }

  function initDealModal(el) {
    // Volume-discount modal (owner spec 2026-09-05). Opens once the page
    // has painted; "session" frequency shows it once per browsing session,
    // "always" on every product page. Closes on the ×, the primary button,
    // the scrim and Escape; focus is trapped while open and restored after.
    var KEY = 'tread_deal_seen';
    var freq = el.getAttribute('data-freq') || 'session';
    if (freq === 'session') {
      try {
        if (sessionStorage.getItem(KEY)) return;
      } catch (e) { /* private mode: fall through and show it once */ }
    }

    var opener = null;

    function focusables() {
      return [].slice.call(el.querySelectorAll(
        'button, a[href], input, [tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      opener = document.activeElement;
      el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      var x = el.querySelector('.tread-deal-modal__x');
      if (x) x.focus();
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* nicety only */ }
    }

    function close() {
      el.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (opener && opener.focus) opener.focus();
    }

    // Only an element marked as a closer closes the modal, so a click
    // anywhere else on the card is inert without needing to stop the
    // event — stopping it here would swallow the × and the button too.
    el.addEventListener('click', function (e) {
      var hit = e.target.closest ? e.target.closest('[data-tread-deal-close]') : null;
      if (hit) {
        e.preventDefault();
        close();
      }
    });

    setTimeout(open, 650);
  }

  function initCollection(root) {
    // Load more: fetch the next paginated page and append its cards.
    var more = root.querySelector('[data-tread-more]');
    var grid = root.querySelector('[data-tread-grid]');
    if (more && grid) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        more.setAttribute('aria-busy', 'true');
        fetch(more.href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-tread-grid]');
            var newMore = doc.querySelector('[data-tread-more]');
            if (newGrid) {
              while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
            }
            if (newMore) {
              more.href = newMore.href;
              more.removeAttribute('aria-busy');
            } else {
              more.remove();
            }
          })
          .catch(function () { window.location.href = more.href; });
      });
    }

    // Filters: submit the form when a value changes.
    var form = root.querySelector('[data-tread-filterform]');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }

    // Mobile filter sheets: the filter strip scrolls sideways and clips
    // vertical overflow, so open panels render as fixed full-width
    // sheets anchored below the strip. One sheet at a time; the anchor
    // tracks page scroll while a sheet is open.
    if (form && window.matchMedia('(max-width: 767px)').matches) {
      var fDetails = [].slice.call(form.querySelectorAll('details.tread-filter'));
      var syncSheetTop = function () {
        if (!fDetails.some(function (d) { return d.open; })) return;
        var top = Math.max(0, form.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--tread-filter-panel-top', top + 'px');
      };
      fDetails.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            fDetails.forEach(function (o) { if (o !== d) o.open = false; });
            syncSheetTop();
          }
        });
      });
      addEventListener('scroll', syncSheetTop, { passive: true });
    }

    // Column switcher: 2/3/4/6 desktop, 1/2 mobile (defaults 4 and 2).
    // The choice sticks for the session; the grid reads it as CSS vars,
    // so load-more appends keep the chosen count. Filter changes reload
    // the page, which re-runs this and re-applies the stored choice.
    var colsWrap = root.querySelector('[data-tread-cols]');
    if (colsWrap && grid) {
      var sGet = function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
      var sSet = function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* per-session nicety only */ } };
      var colsApply = function () {
        var d = sGet('tread_cols_d') || '4';
        var m = sGet('tread_cols_m') || '2';
        grid.style.setProperty('--tread-cols-d', d);
        grid.style.setProperty('--tread-cols-m', m);
        [].slice.call(colsWrap.querySelectorAll('button[data-cols]')).forEach(function (b) {
          var set = b.parentElement.getAttribute('data-cols-set');
          b.classList.toggle('on', b.getAttribute('data-cols') === (set === 'd' ? d : m));
        });
      };
      colsWrap.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-cols]') : null;
        if (!b) return;
        var set = b.parentElement.getAttribute('data-cols-set');
        sSet(set === 'd' ? 'tread_cols_d' : 'tread_cols_m', b.getAttribute('data-cols'));
        colsApply();
      });
      colsApply();
    }

    // Brand line: clamps to two lines on phones with a More/Less toggle;
    // full text on desktop (owner spec 2026-09-01, item 2).
    var bl = root.querySelector('[data-tread-brandline]');
    var blMore = root.querySelector('[data-tread-brandline-more]');
    if (bl && blMore && window.matchMedia('(max-width: 767px)').matches) {
      bl.classList.add('clamp');
      if (bl.scrollHeight > bl.clientHeight + 2) {
        blMore.hidden = false;
        blMore.addEventListener('click', function () {
          var clamped = bl.classList.toggle('clamp');
          blMore.textContent = clamped ? 'More' : 'Less';
        });
      } else {
        bl.classList.remove('clamp');
      }
    }

    // Model chips: counts computed from the full collection product data,
    // then curated — only models with 4+ products, ordered by count, the
    // rest behind "More" (top 6 visible on phones, 12 on desktop; counts
    // are not displayed — owner spec 2026-09-01, item 5). The "All N"
    // chip always stays first; an active chip is always visible.
    var chipRow = root.querySelector('[data-tread-chips]');
    var anchors = chipRow ? [].slice.call(chipRow.querySelectorAll('[data-model-chip]')) : [];
    if (anchors.length) {
      var handle = root.getAttribute('data-handle');
      var counts = {};
      var page = 1;
      var curate = function () {
        var moreBtn = chipRow.querySelector('[data-tread-chips-more]');
        var cap = window.matchMedia('(max-width: 767px)').matches ? 6 : 12;
        var list = anchors.map(function (a) {
          return { a: a, n: counts[a.getAttribute('data-model-chip')] || 0 };
        });
        var qualifying = list.filter(function (x) { return x.n >= 4 || x.a.classList.contains('on'); });
        qualifying.sort(function (x, y) { return y.n - x.n; });
        qualifying.forEach(function (x) { chipRow.insertBefore(x.a, moreBtn); });
        var hiddenRest = [];
        qualifying.forEach(function (x, i) {
          if (i < cap || x.a.classList.contains('on')) x.a.removeAttribute('hidden');
          else hiddenRest.push(x.a);
        });
        if (hiddenRest.length && moreBtn) {
          moreBtn.removeAttribute('hidden');
          moreBtn.addEventListener('click', function () {
            hiddenRest.forEach(function (a) { a.removeAttribute('hidden'); });
            moreBtn.setAttribute('hidden', '');
          });
        }
      };
      var fetchPage = function () {
        fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data && data.products) || [];
            products.forEach(function (p) {
              (p.tags || []).forEach(function (t) {
                if (t.indexOf('model:') === 0) counts[t] = (counts[t] || 0) + 1;
              });
            });
            if (products.length === 250) {
              page += 1;
              fetchPage();
            } else {
              curate();
            }
          })
          .catch(function () { /* chips stay collapsed to "All N" */ });
      };
      fetchPage();
    }
  }
})();
